import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "fixed inset-0 z-50 flex items-center justify-center p-4"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "absolute inset-0 bg-black bg-opacity-50" }, null, -1)
const _hoisted_3 = { class: "relative mx-auto z-10 overflow-hidden rounded-lg bg-white px-4 pb-4 pt-5 text-left shadow-xl transition-all sm:w-2/5 sm:p-6" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("h1", { class: "text-dark-blue text-2xl font-roboto text-center mb-3" }, " Please Complete Account Information ", -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("p", { class: "text-dark-blue text-base text-center" }, " Please complete your account information required for the Section 18A tax certificate. ", -1)
const _hoisted_6 = { class: "flex justify-center gap-x-6 mt-6" }

import { defineComponent } from "vue"


export default /*#__PURE__*/_defineComponent({
  __name: 'TaxInfoConfirmationModal',
  props: {
  show: {
    type: Boolean,
    default: true,
  }
},
  emits: ['close', 'continue'],
  setup(__props, { emit: __emit }) {

const props = __props

const emits = __emit

return (_ctx: any,_cache: any) => {
  return (__props.show)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _hoisted_2,
        _createElementVNode("div", _hoisted_3, [
          _hoisted_4,
          _hoisted_5,
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("button", {
              onClick: _cache[0] || (_cache[0] = ($event: any) => (emits('close'))),
              class: "flex items-center justify-center w-28 py-2 rounded-md shadow-md bg-transparent text-dark-blue border border-dark-blue text-center"
            }, " Cancel "),
            _createElementVNode("a", {
              onClick: _cache[1] || (_cache[1] = ($event: any) => (emits('continue'))),
              class: "flex items-center justify-center w-28 py-2 rounded-md shadow-md bg-light-blue text-white cursor-pointer text-center"
            }, " Continue ")
          ])
        ])
      ]))
    : _createCommentVNode("", true)
}
}

})